const AUTO_RETRY_DELAY_MS = 3_000;

/**
 * `attempts` = quantas tentativas de extracao ja falharam.
 * Uma unica retentativa automatica (a maioria das falhas e transitoria: rede,
 * cold start, rate limit). Depois disso, so manual — retry automatico em loop
 * apenas queimaria tokens em erro deterministico.
 */
export const decideAiRetry = (
  attempts: number,
): { shouldRetryAutomatically: boolean; delayMs: number } => ({
  shouldRetryAutomatically: attempts === 1,
  delayMs: AUTO_RETRY_DELAY_MS,
});
